<template>
  <button
    class="button-scroll"
    :class="{'button-scroll-top': top}"
    :title="buttonData.scroll"
    @click="scrollToNext">
    <svg>
      <use xlink:href="#scrollDownSvg"></use>
    </svg>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ScrollTo',
  props: {
    dark: Boolean,
    top: Boolean,
    where: {
      type: Number
    },
    speed: {
      type: Number,
      default: 1500
    }
  },
  data () {
    return {
      windowHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'buttonData'
    ]),
    scrollTo () {
      return !isNaN(parseFloat(this.where)) && isFinite(this.where) ? this.where : this.windowHeight
    }
  },
  methods: {
    scrollToNext () {
      this.scrollToY(this.scrollTo, this.speed, 'easeInOutQuint')
    },
    scrollToY (scrollTargetY = 0, speed = 2000, easing = 'easeOutSine') {
      let scrollY = window.pageYOffset
      let currentTime = 0

      let time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8))

      let easingEquations = {
        easeOutSine: function (pos) {
          return Math.sin(pos * (Math.PI / 2))
        },
        easeInOutSine: function (pos) {
          return (-0.5 * (Math.cos(Math.PI * pos) - 1))
        },
        easeInOutQuint: function (pos) {
          if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 5)
          }
          return 0.5 * (Math.pow((pos - 2), 5) + 2)
        }
      }
      function tick () {
        currentTime += 1 / 60
        let p = currentTime / time
        let t = easingEquations[easing](p)
        if (p < 1) {
          window.requestAnimFrame(tick)
          window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t))
        } else {
          window.scrollTo(0, scrollTargetY)
        }
      }
      tick()
    }
  },
  mounted () {
    this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.documentElement.getElementsByTagName('body')[0].clientHeight
  }
}
</script>

<style scoped lang="scss">
  .button-scroll {
    &.button-scroll-top {
      svg {
        transform: rotate(180deg);
      }
    }
  }
</style>
